module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), (!!this.google && !!this.map) ? [_c('map-provider', {
    attrs: {
      "google": _vm.google,
      "map": _vm.map
    }
  }, [_vm._t("default")], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6dad04a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/MapLoader.vue
// module id = 1479
// module chunks = 0